import {ChartEventDomainModel} from "./chart-event.domain-model";
import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";
import {GAME_SHOT_CHARTS} from "../../../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";
import {MemberViewModel} from "../../../../yard/member/member-view-model";
import {ChartEventOutcomeViewModel} from "../event-outcome/chart-event-outcome.view-model";
import type {EnumValueViewModel} from "../../../../common/enum-value/models/enum-value.view-model";
import {ChartEventDetailsModel} from "./chart-event.details.model";

export class ChartEventViewModel extends BaseViewModel {
  domainModel: ChartEventDomainModel
  key: String;
  competitorNum: Number;
  time: String;
  status: Number;
  pid: Number;
  line: Number;
  side: Number;
  type: EnumValueViewModel;
  subType: EnumValueViewModel;
  assistPlayerIds: Array<Number>;
  xg: String;
  xgot: String;
  bodyPart: String;
  goalDescription: String;
  shortViewName: String;
  outcome: ChartEventOutcomeViewModel;
  gameId: Number;

  constructor(model: ChartEventDomainModel, sortIndex, isRtl: Boolean, isGameContext: Boolean) {
    super(model);

    this.key = model.key;
    this.sortIndex = sortIndex;
    this.isRtl = isRtl;
    this.competitorNum = model.competitorNum;
    this.time = model.time;
    this.status = model.status;
    this.playerId = model.playerId;
    this.line = model.line;
    this.side = model.side;
    this.type = model.type;
    this.subType = model.subType;
    this.assistPlayerIds = model.assistPlayerIds;
    this.xg = model.xg;
    this.xgot = model.xgot;
    this.bodyPart = model.bodyPart;
    this.goalDescription = model.goalDescription;
    this.shortViewName = model.shortViewName;
    this.outcome = model.outcome && new ChartEventOutcomeViewModel(model.outcome);
    this.gameId = model.gameId;
    this.isGameContext = isGameContext;
  }

  get isHomeCompetitor(): Boolean {
    return this.competitorNum === 1;
  }

  get isAwayCompetitor(): Boolean {
    return this.competitorNum === 2;
  }


  get isMadeShot() {
    return this.type?.value === GAME_SHOT_CHARTS.SHOT_TYPE.made;
  }

  get isMissedShot() {
    return this.type?.value === GAME_SHOT_CHARTS.SHOT_TYPE.miss;
  }

  get player(): MemberViewModel {
    const player: MemberViewModel = this.domainModel.player ? new MemberViewModel(this.domainModel.player) : null

    return player;
  }

  get assistPlayerName(): String {
    return this.domainModel.assistPlayerName;
  }

  get statusName(): String {
    return this.domainModel.statusName;
  }

  get timeAndStatus(): String {
    return `${this.statusName}, ${this.time}`
  }

  get eventDetails(): Map<String, String> {
    const eventDetails = [];
    if (this.isGameContext) {
      if (this.typeName) {

        eventDetails.push(new ChartEventDetailsModel({
          aliasName: "WEB_SHOT_MAP_OUTCOME_SITUATION",
          key: GAME_SHOT_CHARTS.EVENT_DETAILS_KEYS.situation,
          value: this.typeName
        }))
      }
      if (this.bodyPart) {
        eventDetails.push(new ChartEventDetailsModel({
          aliasName: "WEB_SHOT_MAP_OUTCOME_BODY_PART",
          key: GAME_SHOT_CHARTS.EVENT_DETAILS_KEYS.bodyPart,
          value: this.bodyPart
        }))
      }
    } else {
      if (this.time) {
        eventDetails.push(new ChartEventDetailsModel({
          aliasName: "WEB_PENALTY_SHOTS_MINUTE",
          key: GAME_SHOT_CHARTS.EVENT_DETAILS_KEYS.penaltyMinute,
          value: this.time
        }))
      }
      if (this.outcome) {
        eventDetails.push(new ChartEventDetailsModel({
          aliasName: "WEB_PENALTY_SHOTS_OUTCOME",
          key: GAME_SHOT_CHARTS.EVENT_DETAILS_KEYS.penaltyShot,
          value: this.outcome.name
        }))
      }
    }
    eventDetails.push(new ChartEventDetailsModel({
      aliasName: "WEB_SHOT_MAP_OUTCOME_XG",
      key: GAME_SHOT_CHARTS.EVENT_DETAILS_KEYS.xg,
      value: this.xg ? this.xg : "-"
    }))
    eventDetails.push(new ChartEventDetailsModel({
      aliasName: "WEB_SHOT_MAP_OUTCOME_XGOT",
      key: GAME_SHOT_CHARTS.EVENT_DETAILS_KEYS.xGot,
      value: this.xgot ? this.xgot : "-"
    }))

    return eventDetails;
  }

  get isBlockedShot() {
    return this.outcome?.id === GAME_SHOT_CHARTS.OUTCOME_IDS.block;
  }

  get isGoalType() {
    return this.outcome?.id === GAME_SHOT_CHARTS.OUTCOME_IDS.goal;
  }

  get isOwnGoalShot() {
    return this.isGoalType && this.subType?.value === GAME_SHOT_CHARTS.OUTCOME_SUBTYPES.ownGoal;
  }

  get isReverseSide() {
    return this.isRtl ? this.isHomeCompetitor : this.isAwayCompetitor;
  }

  get gameStartTime(): Date {
    return this.domainModel?.game?.startTime;
  }

  get typeName(): String {
    return this.subType?.name || this.type?.name;
  }

  get outcomeAnalyticValue(): Number {
    let value = null

    if(this.isOwnGoalShot){
      value = GAME_SHOT_CHARTS.ANALYTICS.OUTCOME.ownGoal
    } else if (this.isGoalType) {
      value = GAME_SHOT_CHARTS.ANALYTICS.OUTCOME.goal
    } else if (this.outcome?.id === 1) {
      value = GAME_SHOT_CHARTS.ANALYTICS.OUTCOME.missed
    } else {
      value = GAME_SHOT_CHARTS.ANALYTICS.OUTCOME.attemptSaved
    }

    return value
  }

}
